import styled from 'styled-components';


export const ListTitleDefaultBox = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0.3rem 1.5rem;
    &:before {
        content: "";
        background-image: radial-gradient(50% 80% at top, rgba(0,0,0,0.5), transparent);
        opacity:0.5;
        background-repeat: no-repeat;
        background-position: 50% 0;
        background-size: contain;
        position: absolute;
        left: 0;
        top: 0;
        height: 35rem;
        width: 100%;
        z-index: -1;

      @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        height: 25rem;
      }
    }
`;